import {ControlLabel, FormControl, FormGroup} from 'react-bootstrap';
import React, {useCallback} from 'react';
import update from 'immutability-helper';
import {bool, shape, func} from 'prop-types';
import TagSuggestions from '../misc/TagSuggestions';

const propTypes = {
  asset: shape({}),
  disabled: bool,
  onChange: func,
  onSubmit: func,
  createNewTag: func.isRequired
};

const defaultProps = {
  asset: {},
  disabled: false,
  onChange: () => {},
  onSubmit: () => {}
};

const AssetEditForm = ({asset, tags = [], disabled, onChange, onSubmit, createNewTag}) => {
  const handleChange = (e) => {
    e.preventDefault();

    const change = {};

    change[e.target.name] = {
      $set: e.target.value
    };

    onChange(update(asset, change));
  };

  const onDelete = useCallback((tagIndex) => {
    const newData = {
      mediaItem: {}
    };

    const tags = asset.tags;

    const updatedTags = tags.filter((_, i) => i !== tagIndex);

    newData.tags = {
      $set: updatedTags
    };

    const newAsset = update(asset, newData);
    onChange(newAsset);
  }, [asset.tags]);

  const onAddition = useCallback(async (newTag) => {
    const assetData = {
      mediaItem: {}
    };

    const tagsArray = asset.tags;

    if (tagsArray.some((tag) => tag.id === newTag.id)) {
      return;
    }

    // Check if we are dealing with a new tag, and if so send an update to Contentful to create the tag.
    if (!tags.some((tag) => tag.name === newTag.name)) {
      newTag = await createNewTag(newTag);
    }

    tagsArray.push(newTag);

    assetData.tags = {
      $set: tagsArray
    };

    const updatedAsset = update(asset, assetData);
    onChange(updatedAsset);
  }, [asset.tags]);

  const availableSuggestions = tags.filter((tag) => !asset.tags.some((assetTag) => assetTag.id === tag.id));

  return (
    <form onSubmit={onSubmit}>
      <FormGroup>
        <ControlLabel>Tittel</ControlLabel>
        <FormControl
          type="text"
          name="title"
          value={asset.title || ''}
          placeholder="Tittel"
          onChange={handleChange}
          disabled={disabled}
        />
      </FormGroup>

      <FormGroup>
        <ControlLabel>Beskrivelse</ControlLabel>
        <FormControl
          type="text"
          name="description"
          value={asset.description || ''}
          placeholder="Beskrivelse"
          onChange={handleChange}
          disabled={disabled}
        />
      </FormGroup>
      <FormGroup>
        <ControlLabel>Tags</ControlLabel>
        <TagSuggestions
          tags={asset.tags}
          suggestions={availableSuggestions}
          minQueryLength={1}
          onDelete={onDelete}
          onAddition={onAddition}
          allowNew={true}
          newTagText='Opprett ny tag:'
          placeholderText='Begynn å skrive for eksisterende forslag eller opprette nye'
          className="form-control"
        />
      </FormGroup>
      <button type="submit" hidden></button>
    </form>
  );
};

AssetEditForm.propTypes = propTypes;
AssetEditForm.defaultProps = defaultProps;

export default AssetEditForm;
